// First-party visit beacon. Anonymous visitor_id lives in localStorage so
// repeat visits are recognizable; navigator.webdriver flags automated browsers.
const VID_KEY = "nerdy_vid";

function visitorId() {
    let vid = localStorage.getItem(VID_KEY);
    if (!vid) {
        vid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`);
        localStorage.setItem(VID_KEY, vid);
    }
    return vid;
}

export function trackVisit(path) {
    try {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/visit`, {
            method: "POST",
            keepalive: true,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                visitor_id: visitorId(),
                path: path || window.location.pathname,
                referrer: document.referrer || "",
                webdriver: navigator.webdriver === true,
                screen: `${window.screen.width}x${window.screen.height}`,
            }),
        }).catch(() => {});
    } catch {
        // storage/fetch blocked — analytics must never break the app
    }
}
